module.exports = __webpack_public_path__ + "img/GF.d096064f.jpg";